import ChatIcon from "@/assets/icons/ChatIcon";
import EmbeddingIcon from "@/assets/icons/EmbeddingIcon";
import ImageGenerationIcon from "@/assets/icons/ImageGenerationIcon";
import LockIcon from "@/assets/icons/LockIcon";
import MultimodalIcon from "@/assets/icons/MultimodalIcon";
import ShareIcon from "@/assets/icons/ShareIcon";
import SpeechToTextIcon from "@/assets/icons/SpeechToTextIcon";
import TextToSpeechIcon from "@/assets/icons/TextToSpeechIcon";
import { Badge } from "@/components/ui/badge";
import type { LLMModel, TranslateFn } from "../types";

type ModelVisibilityBadgeProps = {
  model: Pick<LLMModel, "is_public" | "is_shared">;
};

export const ModelVisibilityBadge = ({ model }: ModelVisibilityBadgeProps) => {
  if (model.is_shared) {
    return (
      <span className="absolute -bottom-1 -start-1 rounded-full border-2 border-background bg-secondary p-1">
        <ShareIcon className="h-2 w-2 text-[var(--secondary-foreground)]" />
      </span>
    );
  }

  if (!model.is_public) {
    return (
      <span className="absolute -bottom-1 -start-1 rounded-full border-2 border-background bg-secondary p-1">
        <LockIcon className="h-2 w-2 text-[var(--secondary-foreground)]" />
      </span>
    );
  }

  return null;
};

type ModelTypeBadgeProps = {
  model: LLMModel;
  t: TranslateFn;
};

export const ModelTypeBadge = ({ model, t }: ModelTypeBadgeProps) => {
  const iconClassName = "text-[var(--secondary-foreground)]";
  const type = model.is_multimodal
    ? { label: t("aiCatalog.multimodal"), Icon: MultimodalIcon }
    : model.is_embedding_model
      ? { label: t("aiCatalog.embeddingModel"), Icon: EmbeddingIcon }
      : model.is_stt_model
        ? { label: t("aiCatalog.speechToText"), Icon: SpeechToTextIcon }
        : model.is_tts_model
          ? { label: t("aiCatalog.textToSpeech"), Icon: TextToSpeechIcon }
          : model.is_image_generation_model
            ? { label: t("aiCatalog.imageGeneration"), Icon: ImageGenerationIcon }
            : { label: t("aiCatalog.chat"), Icon: ChatIcon };

  return (
    <Badge variant="outline" className="h-6 rounded-lg px-2 py-0.5">
      <type.Icon className={iconClassName} />
      <span className="text-center text-xs font-medium text-foreground">
        {type.label}
      </span>
    </Badge>
  );
};
